<app-dropdown
	name="requisitionStatus"
	label="Status"
	[itemGroups]="[{ items: requisitionStatuses }]"
	[ngModel]="selectedRequisitionStatusName"
	(onSelect)="onSelectRequisitionStatus($event)"
	[testHook]="testHooks.StatusDropdown"
></app-dropdown>
